var _line, _line2, _rect, _rect2, _rect3, _line3, _line4, _path, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionareElectromecanicaCuTemporizareLaAnclansareSiLaRevenire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 162,
    viewBox: "0 0 146 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 107.5,
    y1: 63,
    x2: 107.5,
    stroke: "black",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 107.5,
    y1: 161.898,
    x2: 107.5,
    y2: 98.8984,
    stroke: "black",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 62.4961,
    width: 74.5906,
    height: 36.78,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 62.5,
    width: 37,
    height: 37,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 63,
    width: 36,
    height: 36,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 34.0607,
    y1: 62.9393,
    x2: 70.0607,
    y2: 98.9393,
    stroke: "black",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33.9393,
    y1: 98.9393,
    x2: 69.9393,
    y2: 62.9393,
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 62.5H25.5V99.5H13H0.5V62.5Z",
    fill: "black",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 62.5,
    width: 7,
    height: 37,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionareElectromecanicaCuTemporizareLaAnclansareSiLaRevenire);
export default __webpack_public_path__ + "static/media/actionare_electromecanica_cu_temporizare_la_anclansare_si_la_revenire.79210e53d7be2213be6fe9a9a048717c.svg";
export { ForwardRef as ReactComponent };